module.exports = __webpack_public_path__ + "img/wonga.50ae2e31.svg";